

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface ExpenseParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface Expense {
    id?: string;
    name: string;
    tenantId?: string;
    brandId?: string;
    parameters?: ExpenseParameter[];
    links?: any;
    ledgercode?:string;
    accountGroupId?:number;
    ahCode?:string;
    subHeadCode?:string;
}

export abstract class ExpenseData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<Expense[]>;
  abstract create(url: string,data: Expense): Observable<any>;
  abstract update(url: string,data: Expense): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
